import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import Typography from '../../components/Typography/Typography'
import ErrorWindow from '../../components/Windows/ErrorWindow/ErrorWindow'
import InfoWindow from '../../components/Windows/InfoWindow/InfoWindow'

import useThanksPageFailGtmInfo from 'services/gtm/useThanksPageFailGtmInfo'
import './PaymentFailed.scss'
import hocPaymentFailed from './hocPaymentFailed'

const PaymentFailed = ({ failReferenceNumber, cancelReservation, restoreBooking }) => {
    const intl = useIntl()
    const dispatch = useDispatch()

    useThanksPageFailGtmInfo()

    const referenceNumber = failReferenceNumber

    const handleBackToBasket = () => {
        const bookingid = localStorage.getItem('activeBookingId')
        restoreBooking({ bookingid })
    }

    const handleCancelReservation = () => {
        const bookingid = localStorage.getItem('activeBookingId')
        cancelReservation({ bookingid })
        const referer = localStorage.getItem('referer')
        window.location.replace(referer)
    }

    return (
        <Container fluid className="payment-failed d-flex flex-column align-items-center">
            <Typography variant={'h1'} className={'me-auto'}>
                {intl.formatMessage({ id: 'paymentFailed.pageTitle' })}
            </Typography>

            {referenceNumber && (
                <InfoWindow
                    color={'red'}
                    title={intl.formatMessage({ id: 'windows.notification.title' })}
                    description={intl.formatMessage(
                        { id: 'windows.notification.referenceNumber' },
                        { referenceNumber: referenceNumber }
                    )}
                />
            )}
            <ErrorWindow
                title={intl.formatMessage({ id: 'paymentFailed.title' })}
                description={intl.formatMessage({ id: 'paymentFailed.description' })}
                textButton1={intl.formatMessage({ id: 'paymentFailed.button1' })}
                textButton2={intl.formatMessage({ id: 'paymentFailed.button2' })}
                onClickButton1={() => handleBackToBasket()}
                onClickButton2={() => handleCancelReservation()}
            />
            <img
                src={'images/cinestar/astronaut-with-mobile.png'}
                alt={'astronaut-with-mobile'}
                className={'astronaut-animate w-50 h-auto mt-10'}
            />
        </Container>
    )
}

export default hocPaymentFailed(PaymentFailed)
